module.exports = __webpack_public_path__ + "img/tu03.0379ef3d.png";